import { LoadingSpinner } from '@web_opxp/components';
import { FirebaseSelectors, useTranslation } from '@web_opxp/features';
import { useSelector } from 'react-redux';
import ENV from '../../base/env';
import { getSubscriptions } from '../selectors';
import SubscriptionListItem from './SubscriptionListItem';
import './SubscriptionsList.scss';

interface ISubscriptionsListProps {
  onTerminateSubscription: (id: string | number) => void;
}

export default function SubscriptionsList({ onTerminateSubscription }: Readonly<ISubscriptionsListProps>) {
  const { t } = useTranslation();
  const subscriptions = useSelector(getSubscriptions);
  const firebaseReady = useSelector(FirebaseSelectors.isReady);
  if (!subscriptions || !firebaseReady) {
    return <LoadingSpinner assetsUrl={ENV.AssetsBaseUrl} />;
  }
  function renderSubscriptions() {
    if (!subscriptions || subscriptions.length === 0) {
      return (
        <p data-testid="not-found-message" className="not-found-message">
          {t('manage:Subscriptions.Error.not_found')}
        </p>
      );
    }
    return subscriptions.map((s) => (
      <SubscriptionListItem key={s.id} subscription={s} onTerminateSubscription={onTerminateSubscription} />
    ));
  }
  return (
    <div className="subscriptions-list" data-testid="subscriptions-list">
      {renderSubscriptions()}
    </div>
  );
}
